import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type QuizContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, quizObjective?: string | null, quizQuestionsConfig: { questionCount: number }, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, bookmark?: { id: string } | null, instruction?: { text?: string | null } | null, settings?: { timeLimit?: number | null } | null };


export type QuizContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type QuizContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, quizObjective?: string | null, quizQuestionsConfig: { questionCount: number }, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, bookmark?: { id: string } | null, instruction?: { text?: string | null } | null, settings?: { timeLimit?: number | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type QuizContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizContentCard on QuizContentType {
  id
  name
  type
  status
  quizQuestionsConfig {
    questionCount
  }
  quizObjective: objective
  cover {
    ...EntityMedia
  }
  bookmark {
    id
  }
  instruction {
    text
  }
  settings {
    timeLimit
  }
}
    `;
export const QuizContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizContentCardWithUserPerformance on QuizContentType {
  id
  name
  type
  status
  quizQuestionsConfig {
    questionCount
  }
  quizObjective: objective
  cover {
    ...EntityMedia
  }
  bookmark {
    id
  }
  instruction {
    text
  }
  settings {
    timeLimit
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;